import {
  getSurveyShareUsers,
  putSurveyShareUsers,
  postShareResults,
} from '../services/surveys';

export const useShareSurvey = (surveyId: string) => {
  const getShareUsers = async () => {
    const users = await getSurveyShareUsers(surveyId);
    return users;
  };

  const putShareUsers = async (
    departmentId: number,
    list: number[],
    applyForChild: boolean
  ) => {
    const resp = await putSurveyShareUsers(surveyId, departmentId, {
      access_list: list,
      apply_for_child: applyForChild,
    });
    return resp;
  };

  const postResults = async () => {
    const resp = await postShareResults(surveyId);
    return resp;
  };

  return {
    getSurveyShareUsers: getShareUsers,
    putSurveyShareUsers: putShareUsers,
    postShareResults: postResults,
  };
};
